import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={200}
    height={200}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M511.974 0C230.417 0 0 230.417 0 511.974S230.417 1024 511.974 1024 1024 793.583 1024 511.974 793.583 0 511.974 0zm0 959.855A445.249 445.249 0 0 1 63.99 511.975 445.249 445.249 0 0 1 511.974 63.99a445.249 445.249 0 0 1 447.88 447.984 445.197 445.197 0 0 1-447.88 447.88z"
    />
    <path
      fill="currentColor"
      d="M511.974 159.976c-121.581 0-223.966 102.436-223.966 224.018S390.393 607.96 511.974 607.96s224.018-102.23 224.018-223.966-102.385-224.018-224.018-224.018zm0 383.993A159.976 159.976 0 1 1 671.95 383.994a158.428 158.428 0 0 1-159.976 159.975z"
    />
    <path
      fill="currentColor"
      d="M204.82 851.175c31.996-140.78 159.976-243.215 307.154-243.215s275.21 102.436 307.205 243.215h63.99C844.776 678.4 691.2 543.969 505.576 543.969s-339.2 128.033-377.594 307.206z"
    />
  </svg>
);
export default SvgComponent;
